const initialState = {
  employee: null,
};

export default initialState;
